const Privacy = () => {
  return (
    <svg
      className="privacy-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="79"
      viewBox="0 0 72 79"
      fill="none"
    >
      <path
        d="M57.6667 38V17.1633C57.6669 16.9002 57.6152 16.6396 57.5145 16.3965C57.4138 16.1534 57.2662 15.9326 57.08 15.7466L46.5867 5.25329C46.2119 4.87811 45.7036 4.66709 45.1733 4.66663H6.33333C5.80289 4.66663 5.29419 4.87734 4.91911 5.25241C4.54404 5.62749 4.33333 6.13619 4.33333 6.66663V69.3333C4.33333 69.8637 4.54404 70.3724 4.91911 70.7475C5.29419 71.1226 5.80289 71.3333 6.33333 71.3333H34.3333M17.6667 31.3333H44.3333M17.6667 18H31M17.6667 44.6666H27.6667"
        stroke="white"
        stroke-width="8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M44.3333 4.66663V16C44.3333 16.5304 44.544 17.0391 44.9191 17.4142C45.2942 17.7892 45.8029 18 46.3333 18H57.6667M57.64 48.4166L66.16 50.58C67.0467 50.8066 67.67 51.6133 67.6433 52.5266C67.07 71.72 56 74.6666 56 74.6666C56 74.6666 44.93 71.72 44.3567 52.5266C44.3476 52.0823 44.4893 51.648 44.7586 51.2944C45.028 50.9409 45.4092 50.6891 45.84 50.58L54.36 48.4166C55.4367 48.1433 56.5633 48.1433 57.64 48.4166Z"
        stroke="white"
        stroke-width="8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Privacy;
